<template>
	<div class="classify-list">
		<div class="classify-list-title">
			<span class="classify-list-title-text">{{ classifyData.title }}</span>
			<div class="classify-list-title-plus" @click="classifyData.classClick('add')">
				<el-tooltip class="item" effect="dark" :content="`${$t('add')}${classifyData.title}`" placement="top">
					<i class="el-icon-plus" style="font-size: 14px; color: #095ce5; font-weight: 700"></i>
				</el-tooltip>
			</div>
		</div>
		<div class="classify-table">
			<div class="classify-table-content">
				<el-table
					:data="classifyData.listData"
					style="width: 100%"
					id="tableRowDrop"
					:highlight-current-row="false"
					:show-header="false"
				>
					<el-table-column
						v-for="({ prop, ...rest }, i) in classifyData.columns"
						:key="i"
						:prop="prop"
						v-bind="rest"
						align="center"
						showOverflowTooltip
					>
						<template slot-scope="{ row, $index }">
							<div
								:style="{
									display: 'flex',
									justifyContent: 'space-between',
									padding: ' 10px 8px',
									cursor: 'pointer',
									fontSize: '14px',
									color: '#31363F',
									backgroundColor: classifyData.avtiveIndex == $index ? '#edefff' : 'transparent'
								}"
								:class="{
									avtive_class: classifyData.avtiveIndex == $index
								}"
								@mouseenter="onMouseoverEnvDelBtn($event)"
								@mouseleave="onMouseleaveEnvDelBtn($event)"
								@click="classifyData.avtiveTap($index)"
							>
								<span class="one-line">{{ row[prop] }}</span>

								<span class="classify-table-icon">
									<el-tooltip class="item" effect="dark" :content="$t('rename')" placement="top">
										<i class="iconfont icon-bianji1" @click.stop="classifyData.classClick('edit', $index)"></i>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" :content="$t('delete')" placement="top">
										<i class="iconfont icon-delete" @click.stop="classifyData.classClick('del', $index)"></i>
									</el-tooltip>
								</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "XbdTree",
	props: {
		classifyData: {
			ifShow: false,
			type: Object,
			value: {}
		}
	},
	data() {
		return {
			filterText: "",
			localClassifyData: this.classifyData // 将prop的值复制到本地变量
		};
	},
	methods: {
		onMouseoverEnvDelBtn(event) {
			event.target.parentElement.querySelector(".classify-table-icon").style.cssText += "display:block";
		},

		onMouseleaveEnvDelBtn(event) {
			event.target.parentElement.querySelector(".classify-table-icon").style.cssText += "display:none";
		}
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
		localClassifyData: {
			handler(newValue) {
				this.$emit("update:classifyData", newValue);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
::v-deep.el-table .cell {
	padding: 0;
}
::v-deep.el-table td,
.el-table th {
	padding: 0;
}
::v-deep.el-table tr {
	height: 0;
	line-height: 0;
}
::v-deep.el-table--enable-row-transition .el-table__body td.el-table__cell {
	border-bottom: none;
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td {
	background-color: transparent;
}
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	background-color: #f5f5f5 !important;
}
::v-deep .el-tree-node__content {
	height: 34px !important;
	border-color: #ebeef5 !important;
}
.el-table::before {
	height: 0;
}
.classify-list {
	width: 200px;
	height: 100%;
	display: flex;
	flex-direction: column;

	&-title {
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 200px;
		background-color: #ffffff;
		padding: 21px 0 21px 12px;
		border-right: 1px solid #e7e8eb;
		border-bottom: 1px solid #e7e8eb;
		border-radius: 4px 0 0 0;
		&-text {
			font-weight: 600;
			font-size: 14px;
			color: #17191c;
		}

		&-plus {
			cursor: pointer;
			margin-left: 8px;
			width: 18px;
			height: 18px;
		}
	}
	.classify-table {
		flex: 1;
		background-color: #ffffff;
		border-right: 1px solid #e7e8eb;
		padding: 8px;
		overflow: auto;
		border-radius: 0 0 0 4px;

		&-content {
			height: 100%;

			.avtive_class {
				background: #edefff !important;
			}
		}
		&-icon {
			display: none;
			font-size: 14px;
		}
		.icon-bianji1 {
			margin-right: 5px;
			&:hover {
				color: #095ce6;
			}
		}
		.icon-delete {
			&:hover {
				color: #d54941;
			}
		}
	}
}
.one-line {
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>
